export default __webpack_public_path__ + "static/projuno-logo-c8adb6b7642227d6fea40a4b34a9244e.png";